ExprNode = require('sma.applicant/surveys/logic.coffee').ExprNode
CompareNode = require('sma.applicant/surveys/logic.coffee').CompareNode
ConnectiveNode = require('sma.applicant/surveys/logic.coffee').ConnectiveNode
ArrayNode = require('sma.applicant/surveys/logic.coffee').ArrayNode
FuncNode = require('sma.applicant/surveys/logic.coffee').FuncNode
IndexNode = require('sma.applicant/surveys/logic.coffee').IndexNode
AttrNode = require('sma.applicant/surveys/logic.coffee').AttrNode
IdentifierNode = require('sma.applicant/surveys/logic.coffee').IdentifierNode
ConstNode = require('sma.applicant/surveys/logic.coffee').ConstNode
EvaluationVisitor = require('sma.applicant/surveys/logic.coffee').EvaluationVisitor
exprParser = require('sma.applicant/surveys/exprParser.js')

class ExprParser
	parse:(input)->
		root = exprParser.parse(input)
		@buildExprTree(root)

	buildExprTree: (parsed) ->
		switch parsed.type
			when 'connective','math','compare'
				parsed.left = @buildExprTree parsed.left
				parsed.right = if parsed.right then @buildExprTree parsed.right else parsed.right
				return if parsed.type == 'connective' then ConnectiveNode::parse(parsed) else if parsed.type == 'math' then ExprNode::parse(parsed) else CompareNode::parse(parsed)
			when 'array'
				parsed.id = @buildExprTree parsed.id
				parsed.start = if parsed.start then @buildExprTree parsed.start
				parsed.end = if parsed.end then @buildExprTree parsed.end else parsed.end
				return ArrayNode::parse(parsed)
			when 'func'
				parsed.id = @buildExprTree parsed.id
				params = []
				for param in parsed.params
					params.push @buildExprTree param
				parsed.params = params
				return  FuncNode::parse(parsed)
			when 'index'
				parsed.id = @buildExprTree parsed.id
				parsed.index = @buildExprTree parsed.index
				return IndexNode::parse(parsed)
			when 'attr'
				parsed.id = @buildExprTree parsed.id
				parsed.attr = @buildExprTree parsed.attr
				return AttrNode::parse(parsed)
			when 'id'
				return IdentifierNode::parse(parsed)
			when 'const' then return ConstNode::parse(parsed)

module.exports = ExprParser
